module.exports = __webpack_public_path__ + "static/media/upload-video.de719625.svg";